import { Row } from "@tanstack/react-table";

export function getVisibleAndSortedCells<T>(
  row: Row<T>,
  columnOrder: string[],
) {
  return row.getVisibleCells().sort((a, b) => {
    const indexA =
      columnOrder.indexOf(a.column.id) === -1
        ? columnOrder.indexOf(a.column.parent?.id ?? a.column.id)
        : columnOrder.indexOf(a.column.id);

    const indexB =
      columnOrder.indexOf(b.column.id) === -1
        ? columnOrder.indexOf(b.column.parent?.id ?? b.column.id)
        : columnOrder.indexOf(b.column.id);

    return indexA - indexB;
  });
}
